import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

const CustomScrollbar = ({ height = "100%", children }) => {
  const renderThumbVertical = (style, ...props) => {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: "#B4B4B4",
      width: 5,
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  return (
    <>
      <Scrollbars
        style={{ height }}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        renderThumbVertical={renderThumbVertical}
      >
        {children}
      </Scrollbars>
    </>
  );
};

export default CustomScrollbar;
